(function () {
  var input = document.getElementById('ns_serial_input');
  var btn = document.getElementById('ns_check_btn');
  var status = document.getElementById('ns_status');
  var result = document.getElementById('ns_result');
  var dataEl = document.getElementById('ns_data');

  function setStatus(t) {
    if (status) status.textContent = "STATUS: " + t;
  }
  function show(html) {
    if (!result) return;
    result.innerHTML = html;
    result.style.display = 'block';
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]);
    });
  }

  // Keep status visible if you want; if you want it hidden, uncomment next line:
  // if (status) status.style.display = 'none';

  setStatus("JS loaded ✅");

  // If the page doesn't have the app, exit quietly
  if (!input || !btn || !result || !dataEl) {
    setStatus("App elements not found on this page ❌");
    return;
  }

  var DISCLAIMER =
    "DISCLAIMER: Results above may be affected based on the following criteria.\n\n" +
    "• You are aware of a motor upgrade on your machine.\n" +
    "• You are aware of an upgraded Equalizer or Stitch Regulator, Pro.\n" +
    "• If your machine has a Leeson Motor it is not serviceable.\n" +
    "• If you have a Voyager Machine, it is not serviceable.\n" +
    "• If your machine is older than 2006 it is not serviceable.\n" +
    "• If you have a Diamond, Elara, or Flair it is serviceable.\n";

  function disclaimerBlock() {
    return (
      '<div style="margin-top:14px;padding:12px;border-radius:12px;' +
      'border:1px solid rgba(201,164,76,0.32);background:rgba(201,164,76,0.10);">' +
      '<strong style="color:#f0c46d;">DISCLAIMER:</strong>' +
      '<div style="white-space:pre-wrap;margin-top:6px;color:#f5f7fb;opacity:0.95;">' +
      esc(DISCLAIMER) +
      '</div></div>'
    );
  }

  // ✅ Not Serviceable / Not Supported message with clickable resources (including YouTube link)
  function notServiceableMessageBlock() {
    return (
      '<div style="margin-top:14px;padding:14px;border-radius:12px;' +
        'border:1px solid rgba(201,164,76,0.22);background:rgba(255,255,255,0.03);color:#f5f7fb;line-height:1.55;">' +

        '<div style="font-weight:900;font-size:16px;margin-bottom:10px;">' +
          'I want to reassure you, though—this does not mean you can’t maintain or continue using your machine.' +
        '</div>' +

        '<div style="color:#b2bac8;margin-bottom:10px;">' +
          'The reason we classify certain older machines as non-serviceable is simply due to some original manufacturing components no longer being available. ' +
          'Because of that, we’re unable to perform full factory service or repairs that would require those specific parts.' +
        '</div>' +

        '<div style="font-weight:900;margin-top:10px;margin-bottom:6px;">However, for everyday use and maintenance, you are absolutely good to go:</div>' +

        '<ul style="margin:0 0 10px 18px;color:#b2bac8;">' +
          '<li>You can and should continue oiling your machine</li>' +
          '<li>You can adjust tension, change needles, and perform routine upkeep</li>' +
          '<li>Standard items like needles, bobbins, and oil are still available and compatible with your machine</li>' +
        '</ul>' +

        '<div style="color:#b2bac8;margin-bottom:12px;">' +
          'We strongly encourage you to keep maintaining your machine—many of these machines continue to run well for years with proper care.' +
        '</div>' +

        '<div style="font-weight:900;margin-bottom:6px;">For help with general maintenance and operation, you can use these resources:</div>' +

        '<ul style="margin:0 0 0 18px;color:#b2bac8;">' +
          '<li><a href="https://www.youtube.com/@noltinglongarm" target="_blank" rel="noopener" style="color:#d8bc72;text-decoration:underline;">Nolting YouTube channel</a></li>' +
          '<li><a href="https://nolting.com/pages/resources" target="_blank" rel="noopener" style="color:#d8bc72;text-decoration:underline;">Nolting Resource Center</a></li>' +
          '<li><a href="https://nolting.com/pages/educational-videos" target="_blank" rel="noopener" style="color:#d8bc72;text-decoration:underline;">Educational Videos</a></li>' +
          '<li><a href="https://nolting.com/products/basics-beyond-by-joyce-blowers?_pos=1&_psq=basics+and&_ss=e&_v=1.0" target="_blank" rel="noopener" style="color:#d8bc72;text-decoration:underline;">Back to Basics by Joyce Blowers</a></li>' +
        '</ul>' +
      '</div>'
    );
  }

  function normPrefix(s) {
    var up = String(s || "").toUpperCase();
    var out = "";
    for (var i = 0; i < up.length; i++) {
      var code = up.charCodeAt(i);
      if ((code >= 65 && code <= 90) || (code >= 48 && code <= 57)) out += up[i];
    }
    return out;
  }

  function parseSerial(raw) {
    raw = String(raw || "").trim();
    if (!raw) return null;
    var m = raw.match(/(.*?)(\d+)\s*$/);
    if (!m) return null;

    var num = parseInt(m[2], 10);
    var prefixRaw = m[1].replace(/[\s\-\/\.]+$/g, "");
    var prefix = normPrefix(prefixRaw);
    if (!prefix || isNaN(num)) return null;

    return { raw: raw, prefix: prefix, num: num };
  }

  function inRange(n, a, b) {
    if (a == null && b == null) return false;
    if (a == null) return n <= b;
    if (b == null) return n >= a;
    if (b < a) { var t = a; a = b; b = t; }
    return n >= a && n <= b;
  }

  function span(a, b) {
    if (a == null || b == null) return Number.POSITIVE_INFINITY;
    if (b < a) { var t = a; a = b; b = t; }
    return b - a;
  }

  var rows;
  try {
    rows = JSON.parse(dataEl.textContent || dataEl.innerText || "{}").rows || [];
  } catch (e) {
    setStatus("DATA ERROR ❌ (ns_data is not valid JSON)");
    show(
      '<div style="font-weight:900;font-size:28px;color:#f09b92;">Data Error</div>' +
      '<div style="margin-top:10px;color:#b2bac8;">Your ns_data block is not valid JSON (usually comments or a trailing comma).</div>' +
      disclaimerBlock()
    );
    return;
  }

  var ranges = [];
  for (var i = 0; i < rows.length; i++) {
    var startTok = rows[i][0];
    var endTok = rows[i][1];
    var statusTok = String(rows[i][2] || "").toUpperCase();
    if (statusTok !== "FS" && statusTok !== "NS") continue;

    var start = parseSerial(startTok);
    var end = (endTok && String(endTok).toUpperCase() !== "NA") ? parseSerial(endTok) : null;

    var prefix = (start && start.prefix) || (end && end.prefix);
    if (!prefix) continue;

    ranges.push({
      prefix: prefix,
      start: start ? start.num : null,
      end: end ? end.num : null,
      status: statusTok,
      a: startTok,
      b: endTok
    });
  }

  setStatus("Ready ✅ (" + ranges.length + " ranges loaded)");

  function lookupBest(s) {
    var best = null;
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (r.prefix !== s.prefix) continue;
      if (!inRange(s.num, r.start, r.end)) continue;

      if (!best) { best = r; continue; }
      if (best.status === "FS" && r.status === "NS") { best = r; continue; }
      if (best.status === "NS" && r.status === "FS") continue;
      if (span(r.start, r.end) < span(best.start, best.end)) best = r;
    }
    return best;
  }

  function render(title, color, extraHtml) {
    var html = '<div style="font-weight:1000;font-size:38px;letter-spacing:0.4px;color:' + color + ';">' + title + '</div>';
    if (extraHtml) html += extraHtml;
    html += disclaimerBlock();
    show(html);
  }

  function run() {
    var raw = String(input.value || "").trim();
    var up = raw.toUpperCase();

    // Model override
    if (up.indexOf("DIAMOND") !== -1 || up.indexOf("ELARA") !== -1 || up.indexOf("FLAIR") !== -1) {
      render(
        "Serviceable",
        "#78d9a1",
        '<div style="margin-top:10px;color:#b2bac8;">Model override applied for <strong>Diamond / Elara / Flair</strong>.</div>'
      );
      return;
    }

    var s = parseSerial(raw);
    if (!s) {
      render(
        "Requires Additional Verification",
        "#d2d8e2",
        '<div style="margin-top:10px;color:#b2bac8;"><strong>Your serial Number Requires Additional Verification.</strong></div>'
      );
      return;
    }

    var hit = lookupBest(s);
    if (!hit) {
      render(
        "Requires Additional Verification",
        "#d2d8e2",
        '<div style="margin-top:10px;color:#b2bac8;"><strong>Your serial Number Requires Additional Verification.</strong></div>' +
        '<div style="margin-top:10px;color:#b2bac8;">Entered: <strong>' + esc(s.raw) + '</strong></div>'
      );
      return;
    }

    var ok = hit.status === "FS";
    var title = ok ? "Serviceable" : "Not Serviceable";
    var color = ok ? "#78d9a1" : "#f09b92";

    var extra = '<div style="margin-top:10px;color:#b2bac8;">Matched: <strong>' + esc(hit.a) + ' → ' + esc(hit.b) + '</strong></div>';

    if (!ok) {
      extra += notServiceableMessageBlock();
    }

    render(title, color, extra);
  }

  btn.addEventListener("click", run);
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter") run();
  });
})();